import React from 'react';

export default function DescriptionSplit({ description, theme = "dark", text = "justify", opacity = "60", className = "" }) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(description, 'text/html');
    const emailRegex = /([a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})/g;

    const descriptionSplitted = Array.from(doc.body.childNodes).map((node, index) => {
        if (node.nodeType === Node.TEXT_NODE) {
            const parts = node.textContent.split(emailRegex);
            return (
                <React.Fragment key={index}>
                    {parts.map((part, i) =>
                        emailRegex.test(part) ? (
                            <a key={i} href={`mailto:${part}`} className="underline text-primary hover:text-blue-800">{part}</a>
                        ) : (
                            <React.Fragment key={i}>{part}</React.Fragment>
                        )
                    )}
                    <br />
                </React.Fragment>
            );
        } else if (node.nodeType === Node.ELEMENT_NODE) {
            const Tag = node.tagName.toLowerCase();
            const parts = node.textContent.split(emailRegex);
            return (
                <React.Fragment key={index}>
                    <Tag>
                        {parts.map((part, i) =>
                            emailRegex.test(part) ? (
                                <a key={i} href={`mailto:${part}`} className="underline text-primary hover:text-blue-800">{part}</a>
                            ) : (
                                <React.Fragment key={i}>{part}</React.Fragment>
                            )
                        )}
                    </Tag>
                    <br />
                </React.Fragment>
            );
        }
        return null;
    });

    return (
        <div className={`text-sm md:text-base ${theme === "dark" ? "text-description" : "text-white"} ${text === "justify" ? "text-justify" : "text-center"} opacity-${opacity} ${className} whitespace-pre-wrap`}>
            <div>{descriptionSplitted}</div>
        </div>
    );
}